import { useEffect, useState } from "react";
import { api, formatCompactNumber } from "@/lib/api";

export default function MallOwnerMalls() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/mall-owner/malls").then((r) => setRows(r.data)).catch(() => setRows([])).finally(() => setLoading(false)); }, []);

  return (
    <div data-testid="mall-owner-malls">
      <div className="text-[11px] uppercase tracking-[0.3em] font-semibold text-[var(--gold)]">Your malls</div>
      <h1 className="mt-3 font-serif-display text-4xl text-[var(--ink)]">{rows.length} malls under management</h1>

      {loading ? <div className="mt-8 text-[var(--slate-2)]">Loading…</div> : rows.length === 0 ? (
        <div className="mt-10 surface p-12 text-center">
          <div className="font-serif text-3xl">No malls assigned yet.</div>
          <p className="mt-2 text-[var(--slate-1)]">Our super-admin will link your malls during onboarding.</p>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {rows.map((m) => (
            <div key={m.id} className="surface" data-testid={`mo-mall-${m.id}`}>
              <div className="relative aspect-[16/10] overflow-hidden">
                {m.hero_image && <img src={m.hero_image} alt={m.name} className="absolute inset-0 w-full h-full object-cover img-luxe" loading="lazy" />}
                <div className="absolute top-3 left-3 chip chip-gold chip-active">{m.category}</div>
              </div>
              <div className="p-5">
                <div className="font-serif text-xl text-[var(--ink)]">{m.name}</div>
                <div className="text-xs text-[var(--slate-2)] mt-1">{m.city} · {m.tier}</div>
                <div className="mt-3 grid grid-cols-2 gap-3 text-xs">
                  <Stat label="Ad spaces" value={m.spot_count || "—"} />
                  <Stat label="Monthly ftfl" value={formatCompactNumber(m.monthly_footfall)} />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div>
      <div className="font-serif text-lg text-[var(--ink)]">{value}</div>
      <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--slate-2)]">{label}</div>
    </div>
  );
}
